import { Language } from './language.model';
import { RouteInfo } from './route-info';

export class Config {
  apiUrl: string;
  mediaUrl: string;
  sidebarRoutes: RouteInfo[];
  languages: Language[];
}
